import * as d3 from 'd3';
import i18next from 'i18next';

import * as map from "../mapping.js";
import * as utilities from "../utilities.js";
import elements from '../elements/index.js';
import charts from "../charts/index.js";
import data_processing from "../data_processing/index.js";
// ====================================explanstion==============================================
let explanations = {
    "page1_sec1_title": "依 (多值) 後設資料欄位，統計資料集所擁有該欄位的項目數量。其中盒鬚圖的最大值與最小值，以 Q3 + 1.5 x IQR 與 Q1 - 1.5 x IQR (IQR: 四分位距) 計算。",
    "page1_sec2_title" :"統計各後設資料欄位項目被資料集使用的情形。並以長條圖與圓餅圖呈現擁有最多資料集的前十個項目。",
    "page1_sec3_title": "統計各後設資料欄位中，各項目在資料集中的出現頻率，呈現各項目中頻率最高者。統計分母為所有資料集數量，分子為該項目的出現頻率。例如，一資料集雖可能包含多個 PDF 類型的資源，然只要出現過，無論數量，均以 1 計數。",
    "page1_sec4_title": "以表格呈現指定日期的各後設資料欄位值的統計狀態。總數量為該後設資料欄位項目出現於多少個資料集。"
};

let stats_data;
let daily_fetch_data;
let num_dataset;
// ====================================main======================================================
(async () => {
    try {
        await window.i18nReady;

        $('#languageSwitcher').on('change', function() {
            const selectedLang = $(this).val();
            i18next.changeLanguage(selectedLang, function(err, t) {
                // Update dataTables
                update_table(cur_table_tab.id, date_picker.value, map.table_column_mapping);

                // Update labels for histogram
                const x_hist_label = document.querySelector('#dataset_hist text.hist_x_title');
                cur_hist_tab = document.querySelector('#num_tabs li button.active');
                each_hist_label = i18next.t("num_of");
                item_hist_label = cur_hist_tab.textContent;

                if(item_hist_label == "Wikidata 關鍵字") {
                    item_hist_label = " Wikidata 關鍵字";
                }

                x_hist_label.textContent = `${each_hist_label}${item_hist_label}`;
                
                // Update labels for area chart
                const x_label = document.querySelector('#dataset_trend text.area_chart_x_title');
                const x_label_sm = document.querySelector('#top_10_chart text.area_chart_x_title'); // side bar chart
                cur_tab = document.querySelector('#chart_tabs li button.active');
                each_label = i18next.t("each_label");
                item_label = cur_tab.textContent;

                if(item_label == "Wikidata 關鍵字") {
                    item_label = " Wikidata 關鍵字";
                }

                x_label.textContent = `${each_label}${item_label}`;
                x_label_sm.textContent = `${each_label}${item_label}`;

                // remove old popover
                document.querySelectorAll(".info_btn").forEach(el => el.remove());
                elements.info.gen_popover("h5.section_title", explanations);
            });
        });

        // Popover
        elements.info.gen_popover("h5.section_title", explanations);

        // Obtain update_time
        const update_time = await data_processing.update_time.get_update_time();
        utilities.update_update_time_display(update_time);

        // Load the Daily Stats Data
        const update_month = update_time.slice(0,7);
        stats_data = await utilities.load_daily_stats_data(update_month);

        // Load the Daily Fetch Data
        daily_fetch_data = await data_processing.file.fetch_data_by_date(update_time);

        // Obtain number of dataset
        num_dataset = await data_processing.number_of_data.num_of_dataset(stats_data, 0);

        // ====================================page_elems===============================================
        // Sec#1: Statistics
        const stats_map = map.dataset_stats_mapping;

        // Generate Tabs
        elements.radio.gen_radio_tabs('num_tabs', stats_map);
        const stats_tabs_items = document.querySelectorAll('#num_tabs li button.nav-link');
        const init_tab = document.querySelector('#num_tabs li button#data_type_tab');
        init_tab.classList.add("active"); // init tabs

        // Count Data
        let array_data = data_processing.number_of_data.num_of_obj_and_arr(daily_fetch_data, 'data_type');
        let mean = data_processing.statistics.mean(array_data);
        let median = data_processing.statistics.median(array_data);
        let mode = data_processing.statistics.mode(array_data);
        elements.cards.stats_card('mean', '平均數', mean);
        elements.cards.stats_card('median', '中位數', median);
        elements.cards.stats_card('mode', '眾數', mode);

        // Generate Histogram & Box plot
        charts.histogram.gen_hist('dataset_hist', array_data, 500);
        charts.box_plot.gen_box('dataset_box', array_data);

        const x_hist_label = document.querySelector('#dataset_hist text.hist_x_title');
        let cur_hist_tab = document.querySelector('#num_tabs li button.active');
        let each_hist_label = i18next.t("num_of");
        let item_hist_label = cur_hist_tab.textContent;

        x_hist_label.textContent = `${each_hist_label}${item_hist_label}`;

        stats_tabs_items.forEach(item => {
            item.addEventListener('click', function(event) {
                event.preventDefault();
                let key = item.id.split("_tab")[0]

                if(key == "resources"){
                    key = "num_resources"
                }
                
                // array_data: An array where each element represents the 'count' of the selected 'key' in each dataset.
                array_data = data_processing.number_of_data.num_of_obj_and_arr(daily_fetch_data, key);
                charts.histogram.update_hist('dataset_hist', array_data, 500)
                charts.box_plot.update_box('dataset_box', array_data)

                // Update x-asix
                const x_hist_label = document.querySelector('#dataset_hist text.hist_x_title');
                let item_hist_label = this.textContent;

                if(item_hist_label == "Wikidata 關鍵字") {
                    item_hist_label = " Wikidata 關鍵字";
                }

                x_hist_label.textContent = `${each_hist_label}${item_hist_label}`;
                update_chart(key, chart_control);

                // Count mean, 
                mean = data_processing.statistics.mean(array_data);
                median = data_processing.statistics.median(array_data);
                mode = data_processing.statistics.mode(array_data);
                elements.cards.stats_card('mean', '平均數', mean);
                elements.cards.stats_card('median', '中位數', median);
                elements.cards.stats_card('mode', '眾數', mode);
            });
        });  
        // ===================================================================================
        // Sec#2: Dataset Trend (Left Side)

        // Generate Tabs
        elements.radio.gen_radio_tabs('chart_tabs', map.dataset_all_mapping);
        const chart_tab_items = document.querySelectorAll('#chart_tabs li button.nav-link');
        const chart_init_tab = document.querySelector('#chart_tabs li button#organizations_tab');
        chart_init_tab.classList.add("active"); // init tabs

        let total_data_trend = await data_processing.number_of_data.top_n_data(stats_data, num_dataset, 'organizations', 'count');
        charts.area_chart.area_chart("dataset_trend", total_data_trend);

        const x_label = document.querySelector('#dataset_trend text.area_chart_x_title');
        let cur_tab = document.querySelector('#chart_tabs li button.active');
        let each_label = i18next.t("each_label");
        let item_label = cur_tab.textContent

        x_label.textContent = `${each_label}${item_label}`;

        chart_tab_items.forEach(item => {
            item.addEventListener('click', async function(event) {
                // Click the dropdown
                event.preventDefault();

                // Select Indicator
                const column_name = item.id.split("_tab")[0]

                // Top Data
                total_data_trend = await data_processing.number_of_data.top_n_data(stats_data, num_dataset, column_name, 'count');
                
                // Update Trend Chart
                charts.area_chart.update_area_chart("dataset_trend", total_data_trend);

            });
        });

        // ===================================================================================
        // Sec#2: Bar & Pie Chart Switch (Right Side)
        async function update_chart(category, chart_btn) {
            let top_data = await data_processing.number_of_data.top_n_data(stats_data, 10, category, 'count');
            let total_data = await data_processing.number_of_data.top_n_data(stats_data, num_dataset, category, 'count');
            const chart_info = $('.chart_name.col');

            // Show Bar Chart
            if(chart_btn == "bar_btn") {
                // Init
                chart_info.empty().append(
                    $('<p>', {
                        class: 'card-sm-num text-center',
                        'data-i18n': 'click-more'
                        }
                    )
                );
                chart_info.localize();
                // Update
                charts.bar_chart.update_vertical_bar_chart(top_data, "top_10_chart", ".chart_name.col");

                const x_label_sm = document.querySelector('#top_10_chart text.area_chart_x_title');
                let cur_tab = document.querySelector('#chart_tabs li button.active');
                let each_label = i18next.t("each_label");
                let item_label = cur_tab.textContent
                x_label_sm.textContent = `${each_label}${item_label}`;
            }
            // Show Pie Chart
            else if (chart_btn == "pie_btn") {
                // Append "Others" (data other than the top 10)
                let other = {
                    "name": "others",
                    "display_name": "其他",
                    "count": data_processing.number_of_data.total_count(total_data) - data_processing.number_of_data.total_count(top_data)
                };
                top_data.push(other);
                // Init
                chart_info.empty().append(
                    $('<p>', {
                        class: 'card-sm-num text-center',
                        'data-i18n': 'click-more'
                    })
                );
                chart_info.localize();
                // Update
                charts.pie_chart.update_pie_chart(top_data, "top_10_chart", ".chart_name.col");
            }
        }

        // Declare Radio Buttons
        const radios = document.querySelectorAll('input[name="chart_radio"]');
        let chart_control = "bar_btn";

        // Init Data and Bar Chart
        let top_data = await data_processing.number_of_data.top_n_data(stats_data, 10, 'organizations', 'count');
        charts.bar_chart.vertical_bar_chart(top_data, "top_10_chart", ".chart_name.col");

        const x_label_sm = document.querySelector('#top_10_chart text.area_chart_x_title');
        x_label_sm.textContent = `${each_label}${item_label}`;

        radios.forEach(radio => {
            radio.addEventListener('change', (event) => {
                event.preventDefault();
                chart_control = event.target.id;
                const cur_tab = document.querySelector('#chart_tabs li button.active');
                const column_name = cur_tab.id.split("_tab")[0]
                update_chart(column_name, chart_control);
            });
        });

        chart_tab_items.forEach(item => {
            item.addEventListener('click',async function(event) {
                event.preventDefault();
                const cur_tab = document.querySelector('#chart_tabs li button.active');
                const column_name = cur_tab.id.split("_tab")[0]
                await update_chart(column_name, chart_control);

                const x_label = document.querySelector('#dataset_trend text.area_chart_x_title');
                const x_label_sm = document.querySelector('#top_10_chart text.area_chart_x_title');
                const each_label = i18next.t("each_label");
                let item_label = this.textContent;

                if(item_label == "Wikidata 關鍵字") {
                    item_label = " Wikidata 關鍵字";
                }

                x_label.textContent = `${each_label}${item_label}`;
                x_label_sm.textContent = `${each_label}${item_label}`;
            });
        });

        // ===================================================================================
        // Sec#3: Progress bar (Left Side)
        for (let column in map.dataset_all_mapping) {
            let count_method = 'count';
            if (column == 'resources_formats') {
                count_method = 'presence'
            }
            charts.progress_bar.generate_progress_bar_div(stats_data, 'top_data', column, count_method, map.top_datasets_mapping);
        }
        // ===================================================================================
        // Sec#3: DataTable
        function update_table(tab_id, date, mapping) {
            const key = tab_id.split("_tab")[0]
            elements.tables.daily_stats_table("data_table", key, selected_file, date, mapping);
        }
        const data_table_map = map.dataset_all_mapping;

        // Generate Tabs
        elements.radio.gen_radio_tabs('table_tabs', data_table_map);
        const table_tabs_items = document.querySelectorAll('#table_tabs li button.nav-link');
        const init_table_tab = document.querySelector('#table_tabs li button#organizations_tab');
        let cur_table_tab = init_table_tab;
        cur_table_tab.classList.add("active"); // init tabs

        // Create DataTable (Init)
        elements.tables.daily_stats_table("data_table", "organizations", stats_data, update_time, map.table_column_mapping);
        // Select File Date
        const date_picker = document.getElementById('file_date');
        date_picker.value = update_time; // Init Date Picker Value
        let selected_file = stats_data; // Init Data File

        date_picker.addEventListener('change', async (e) => {
            try {
                let selected_date = e.target.value;
                const folder_name = selected_date.slice(0, 7);
                if(folder_name != update_time.slice(0, 7)) {
                    const filepath = `dataset/stats_data/${folder_name}/${folder_name}.csv`;
                    selected_file = await d3.csv(filepath);
                }

                let date_idx = elements.tables.daily_stats_table("data_table", "organizations", selected_file, selected_date, map.table_column_mapping);
                if (date_idx == -1) {
                    window.alert(`所選日期沒有可用的資料\nNo available data.`);
                    e.target.value = update_time;
                    cur_table_tab.classList.remove("active");
                    cur_table_tab = init_table_tab;
                    cur_table_tab.classList.add("active");
                }
                update_table(cur_table_tab.id, selected_date, map.table_column_mapping);

            } catch (error) {
                window.alert("資料格式不供預覽\nNo available data.");
                e.target.value = update_time;
                cur_table_tab.classList.remove("active");
                cur_table_tab = init_table_tab;
                cur_table_tab.classList.add("active");
            }
        });

        table_tabs_items.forEach(item => {
            item.addEventListener('click', function(event) {
                event.preventDefault();
                cur_table_tab = this;
                update_table(cur_table_tab.id, date_picker.value, map.table_column_mapping);
            });
        });

        elements.spinner.hideSpinner("loadingOverlay");    
    } catch (error) {
    }
})();